import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appApenasAlfaNumerico]'
})
export class ApenasAlfaNumericoDirective {

  @Input() permitirEspaco: boolean = false; // Permitir espaços (opcional)
  @Input() permitirAcentos: boolean = false; // Permitir acentuação (opcional)
  @Input() apenasLetras: boolean = false; // Permitir apenas letras (opcional)


  constructor(private el: ElementRef) {}

  @HostListener('keypress', ['$event']) onKeyPress(event: KeyboardEvent): void {
    const inputChar = String.fromCharCode(event.keyCode || event.charCode);
    this.validate(event, inputChar);
  }

  @HostListener('paste', ['$event'])
  onPaste(event: Event) {
    const pastedText = (window as any).clipboardData && (window as any).clipboardData.getData('Text') // If IE, use window
      || event as ClipboardEvent && (event as ClipboardEvent).clipboardData.getData('text/plain'); // Non-IE browsers
    this.validate(event, pastedText);
  }

  validate(event: Event, text: string) {
    let regexPattern: string;

    if (this.apenasLetras) {
      if (this.permitirEspaco && this.permitirAcentos) {
        regexPattern = '^[a-zA-Z\\sáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]*$';
      } else if (this.permitirEspaco && !this.permitirAcentos) {
        regexPattern = '^[a-zA-Z\\s]*$';
      } else if (!this.permitirEspaco && this.permitirAcentos) {
        regexPattern = '^[a-zA-ZáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]*$';
      } else {
        regexPattern = '^[a-zA-Z]*$';
      }
    } else {
      if (this.permitirEspaco && this.permitirAcentos) {
        regexPattern = '^[a-zA-Z0-9\\sáàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]*$';
      } else if (this.permitirEspaco && !this.permitirAcentos) {
        regexPattern = '^[a-zA-Z0-9\\s]*$';
      } else if (!this.permitirEspaco && this.permitirAcentos) {
        regexPattern = '^[a-zA-Z0-9áàâãéèêíïóôõöúçñÁÀÂÃÉÈÊÍÏÓÔÕÖÚÇÑ]*$';
      } else {
        regexPattern = '^[a-zA-Z0-9]*$';
      }
    }

    const regex = new RegExp(regexPattern);
    if (!regex.test(text)) {
      event.preventDefault();
    }
  }
}
